import defaultAvatar from 'assets/user-avatar.png'

const getPicture = (picture?: string | null, fallback = defaultAvatar) =>
  picture || fallback

export default getPicture
